import { API_BASE_URL } from "./constants";

// Pages that work without logging in (public website, login, borrower links)
const PUBLIC_PAGES = [/^\/$/, /^\/login\/?$/i, /^\/case-files\//i, /^\/RESEAA\//i];

// Login token saved by AuthProvider (localStorage "user" = login response array)
export const getToken = () => {
  try {
    const saved = JSON.parse(localStorage.getItem("user"));
    return (Array.isArray(saved) ? saved[0] : saved)?.token || null;
  } catch {
    return null;
  }
};

// For API files opened without fetch (new tab, <img>, iframe src): the token goes in the URL
export const authUrl = (url) => {
  const token = getToken();
  if (!token) return url;
  return `${url}${url.includes("?") ? "&" : "?"}access_token=${encodeURIComponent(token)}`;
};

const isApiRequest = (url) => url.startsWith(API_BASE_URL);
const isLoginRequest = (url) => /\/(api|auth)\/(users|login)(\?|$)/i.test(url);

// Session expired or missing: clear it and go to the login page (not on public pages)
const handleUnauthorized = () => {
  localStorage.removeItem("user");
  if (!PUBLIC_PAGES.some((page) => page.test(window.location.pathname))) {
    window.location.assign("/login");
  }
};

// Adds the login token to every fetch call to our API and handles expired sessions in one place
export const installAuthFetch = () => {
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init = {}) => {
    const url = typeof input === "string" ? input : input?.url || String(input);
    if (!isApiRequest(url) || isLoginRequest(url)) {
      return originalFetch(input, init);
    }

    const token = getToken();
    const headers = new Headers(init.headers || (input instanceof Request ? input.headers : undefined));
    if (token && !headers.has("Authorization")) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    const response = await originalFetch(input, { ...init, headers });
    if (response.status === 401) {
      handleUnauthorized();
    }
    return response;
  };
};

// XMLHttpRequest uploads (progress bars) can't use the fetch wrapper
export const setAuthHeader = (xhr) => {
  const token = getToken();
  if (token) xhr.setRequestHeader("Authorization", `Bearer ${token}`);
};
